export default __webpack_public_path__ + "static/media/tv_1.b05af2f5.mp4";